import { d as u } from "./defaultTheme-9f1e13f4.js";
import { T as h } from "./identifier-2b569a98.js";
import { _ as f } from "./extends-e3d0fd9d.js";
import { u as m } from "./useTheme-89580aa5.js";
function i(n, s) {
  const e = f({}, s);
  return Object.keys(n).forEach((t) => {
    if (t.toString().match(/^(components|slots)$/))
      e[t] = f({}, n[t], e[t]);
    else if (t.toString().match(/^(componentsProps|slotProps)$/)) {
      const o = n[t] || {}, c = s[t];
      e[t] = {}, !c || !Object.keys(c) ? e[t] = o : !o || !Object.keys(o) ? e[t] = c : (e[t] = f({}, c), Object.keys(o).forEach((r) => {
        e[t][r] = i(o[r], c[r]);
      }));
    } else
      e[t] === void 0 && (e[t] = n[t]);
  }), e;
}
function l(n) {
  const {
    theme: s,
    name: e,
    props: t
  } = n;
  return !s || !s.components || !s.components[e] || !s.components[e].defaultProps ? t : i(s.components[e].defaultProps, t);
}
function d({
  props: n,
  name: s,
  defaultTheme: e,
  themeId: t
}) {
  let o = m(e);
  return t && (o = o[t] || o), l({
    theme: o,
    name: s,
    props: n
  });
}
function j({
  props: n,
  name: s
}) {
  return d({
    props: n,
    name: s,
    defaultTheme: u,
    themeId: h
  });
}
export {
  d as a,
  i as r,
  j as u
};
//# sourceMappingURL=useThemeProps-14bb9b11.js.map
